import { Node } from 'reactflow';
import { NodesTypes } from '@constants/canvas/general';
import { NodeDTOTypes } from '@store/services/nodes/types';
import { traverseNodes } from '@views/Insights/Stage/helpers';

/**
 * Builds set of focusedIds based on parent and childrenIds
 */
export const getFocusedNodeIds = (
  nodes: Node[],
  sourceId: string,
): string[] => {
  const focusedIds = new Set<string>(
    nodes.reduce<string[]>((acc, node) => {
      if (node.type !== NodesTypes.CustomNode) acc.push(node.id);

      return acc;
    }, []),
  );

  traverseNodes(nodes, focusedIds, sourceId, true, true, true);

  return Array.from(focusedIds);
};

const hasVisibleFocusTargets = (nodes: Node[], sourceId: string): boolean => {
  const focusedIds = new Set(getFocusedNodeIds(nodes, sourceId));

  return nodes.some(
    (node) =>
      node.type === NodesTypes.CustomNode &&
      node.id !== sourceId &&
      !node.hidden &&
      focusedIds.has(node.id),
  );
};

export const isFocusEligible = (
  node: Node,
  multiSelectionCount: number,
  nodes: Node[],
): boolean => {
  const dto = node.data?.dto;
  if (!dto) return false;

  return (
    dto.type !== NodeDTOTypes.Asset &&
    multiSelectionCount < 2 &&
    hasVisibleFocusTargets(nodes, node.id)
  );
};
